const ApiLogReport = (params, response) => {
  if (process.env.VUE_APP_NODE_ENV !== "production") {
    // 生产环境
    return;
  }
  // 运行平台
  const userAgent = navigator.userAgent;
  // 当前页面信息
  const router = window.location || "";
  // 状态码
  let status = response.status || 10000
  if(response && response.message && response.message.indexOf('Request failed with status code')>-1){
    status = response.message.replace('Request failed with status code ', '')
  }
  // 日志信息
  let logs = {
    userAgent,
    page: router,
    params,
    url: params.url || "",
    response,
    status,
    message: response.message || '',
    source: 'pc'
  };
  // 日志库：
  // endpoint = 'cn-shenzhen.log.aliyuncs.com'
  // project = 'io-event'
  // logstore = 'xiao-mp-survey-test'
  // POST {project}.{endpoint}/logstores/{logstoreName}/track HTTP/1.1
  let logstore = "kuaisou-pc-request-logs";
  let source = "快搜pc端接口请求";
  const logUrl = `https://pcauto-c-front-logs.cn-shanghai.log.aliyuncs.com/logstores/${logstore}/track`;
  const sendObj = {
    __logs__: [{ info: JSON.stringify(logs) }],
    __topic__: "快搜pc端接口请求日志",
    __source__: source,
  };
  const xhr = new XMLHttpRequest();
  xhr.open("POST", logUrl, true);
  xhr.setRequestHeader("Content-Type", "application/x-protobuf; charset=utf-8");
  xhr.setRequestHeader("x-log-apiversion", "0.6.0");
  xhr.setRequestHeader("x-log-bodyrawsize", "53421");
  xhr.send(JSON.stringify(sendObj));
  xhr.onload = (res) => {
    // console.log('success = ', res)
  };
  xhr.onerror = (err) => {
    // console.log('error = ', err)
  };
};

export default ApiLogReport;
